<template>
  <div>
    <CCol xl="12" lg="12" md="12" style="margin-top: 20%" v-if="Spinner">
      <div
        class="sk-wave primary"
        color="success"
        style="margin: auto; width: 10%; top: 50% !important"
      >
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
      </div>
    </CCol>
    <CCard style="margin-top: 20px" v-else>
      <CCardHeader>
        <div style="margin: auto">
          <DatePicker
            v-model="value1"
            type="date"
            range
            placeholder="Select date range"
            style="float: left"
          ></DatePicker>
        </div>
        <CButton
          color="success"
          style="margin-left: 15px"
          v-if="tbl2"
          @click="refresh()"
          >Go to all data</CButton
        >
        <JsonCSV
          v-if="tbl1"
          style="background-color: #4638c2; color: white; float: right"
          color="primary"
          class="btn btn-default mb-2 clr"
          :data="tableData"
          name="rage_capture-list.csv"
        >
          Download CSV (This is a slot)
        </JsonCSV>
        <JsonCSV
          v-if="tbl2"
          style="background-color: #4638c2; color: white; float: right"
          color="primary"
          class="btn btn-default mb-2 clr"
          :data="tableData2"
          name="rage_capture-list.csv"
        >
          Download CSV (This is a slot)
        </JsonCSV>
      </CCardHeader>

      <CCardBody>
        <CDataTable
          v-if="tbl1"
          :items="tableData"
          :fields="fields"
          column-filter
          table-filter
          items-per-page-select
          :items-per-page="10"
          hover
          sorter
          pagination
        >
        <template #transaction_hash="{ item }" style="margin: 10px;">
        <CButton   v-if="item.Result != 'break'" color="primary" @click="filterdata(item.id,item.tokenName)" style="    margin-top: 7px;"
                >View users</CButton
              ></template>
        </CDataTable>
        <CDataTable
          v-if="tbl2"
          :items="tableData2"
          :fields="fields"
          column-filter
          table-filter
          items-per-page-select
          :items-per-page="10"
          hover
          sorter
          pagination
        >
        <template #transaction_hash="{ item }" style="margin: 10px;" >
        <CButton  v-if="item.Result != 'break'"  color="primary" @click="filterdata(item.id,item.tokenName)" style="    margin-top: 7px;"
                >View users </CButton
              ></template>
          <template #Result="{ item }">
            <td >
              <span v-if="item.Result == 'break'">
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  class="badge badge-danger ml-1"
                >
                <b>{{item.Result}}</b>
                </a></span
              >
              <span v-else-if="item.Result == 'Match Cancelled No Result'">
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  class="badge badge-warning ml-1"
                >
                <b>{{item.Result}}</b>
                </a></span
              >
              <span v-else>
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  class="badge badge-success ml-1"
                >
                <b>{{item.Result}}</b>
                </a></span
              >
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>
<style src="spinkit/spinkit.min.css"></style>
<script>
import firebase from "firebase";
const db = firebase.firestore();
import Swal from "sweetalert2";
import moment from "moment";
import JsonCSV from "vue-json-csv";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { secondaryDatabase } from "./secondary.js";
export default {
  components: {
    JsonCSV,
    DatePicker,
  },
  data() {
    return {
      activeTab: 1,
      value1: [],
      tbl1: true,
      tbl2: false,
      Spinner: true,
      tableData: [],
      userdata: [],
      tableData2: [],
      url: "https://polygonscan.com/tx/",
      fields: [
        {
          label: "Date",
          key: "Created",
          sortable: true,
        },

        {
          label: "Match",
          key: "match",
          sortable: true,
        },
        {
          label: "Token Name",
          key: "tokenName",
          sortable: true,
        },
        {
          label: "Answer",
          key: "Result",
          sortable: true,
        },
        // {
        //   label: "Wallet",
        //   key: "ethaddress",
        //   sortable: true,
        // },

        {
          label: "status",
          key: "transaction_hash",
          sortable: true,
        },
      ],
    };
  },
  watch: {
    value1() {
      var res = new Date(this.value1[1]);
      res.setDate(res.getDate() + 1);

      let v1 = firebase.firestore.Timestamp.fromDate(new Date(this.value1[0]));
      let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));
      this.tableData = [];
      secondaryDatabase
        .collection("bettingtest")
        .where("quizdate", ">=", v1)
        .where("quizdate", "<=", v2)
        .orderBy("quizdate", "desc")

        .get()
        .then((snapshot) => {
          this.tableData2 = [];
          snapshot.forEach((doc) => {
            this.Spinner = false;
            this.tbl1 = false;
            this.tbl2 = true;
            let backenddate = moment(doc.data().quizdate.seconds * 1000).format(
              "DD-MMM-YYYY"
            );
            if (doc.data().answer) {
              this.tableData2.push({
                id: doc.id,
                Created: backenddate,
                match: doc.data().team1 + " VS " + doc.data().team2,
                Result: doc.data().answer,
                transaction_hash: doc.data().winnersList
                  ? doc.data().winnersList
                  : null,
                  tokenName:doc.data().tokenName?doc.data().tokenName:"RAGE"
              });
            }
          });
        });
    },
  },
  methods: {
    filterdata(DocId,tokenName) {
      // console.log("DocId",DocId,tokenName);
      // tokenName:doc.data().tokenName?doc.data().tokenName:"RAGE"
      this.$router.push({ name: "predictionUsers", params: { id: DocId,tokenName:tokenName } });
    },
    openlink(hash) {
      window.open(hash, "_blank");
    },
    refresh() {
      window.location.reload();
      // this.tbl1=true;
      //  this.tbl2=false;
    },

    getquiz() {
      var startOfToday = new Date();
      startOfToday.setHours(0, 0, 0, 0);
      var endOfToday = new Date();
      endOfToday.setHours(23, 59, 59, 999);

      secondaryDatabase
        .collection("bettingtest")
        .where("quizdate", ">=", startOfToday)
        .where("quizdate", "<=", endOfToday)
        .orderBy("quizdate", "desc")

        .get()
        .then((snapshot) => {
          if (!snapshot.empty) {
            this.tbl1 = true;
            this.tbl2 = false;
            snapshot.forEach((doc) => {
              this.Spinner = false;
              let backenddate = moment(
                doc.data().quizdate.seconds * 1000
              ).format("DD-MMM-YYYY");

              if (doc.data().answer) {
                this.tableData.push({
                  id: doc.id,
                  Created: backenddate,
                  match: doc.data().team1 + " VS " + doc.data().team2,
                  Result: doc.data().answer,
                  transaction_hash: doc.data().winnersList
                    ? doc.data().winnersList
                    : null,
                    tokenName:doc.data().tokenName?doc.data().tokenName:"RAGE"
                });
              }
            });
          } else {
            this.Spinner = false;
            this.tableData = [];
          }
        });
    },
    assignsmallData(doc) {
      let smallDocument = {
        id: doc.id,
        // quizTitle: doc.data().team1,
        // question: doc.data().team2,
        // options: doc.data().options,
        // answer: doc.data().answer,
        status: doc.data().status ? "Active" : "InActive",
        // image: doc.data().image,
        // quiztype: doc.data().quiztype,
        // starttime: doc.data().starttime,
        // endtime: doc.data().endtime,
        // scramble: doc.data().scramble,
        // dfs: doc.data().dfs,
        Match: doc.data().team1 + " vs " + doc.data().team2,
        Answer: doc.data().answer != null ? doc.data().answer : "Not Answered",
        Created: moment(doc.data().quizdate * 1000).format(
          "DD-MMM-YYYY , hh:mm:ss:a"
        ),
        // TeamOneusercount:doc.data().team1+" - "+doc.data().team1usercount,
        // TeamTwousercount:doc.data().team2+" - "+doc.data().team2usercount,
        // Drawusercount:"Draw"+" - "+doc.data().team3usercount,
        // TotalUsercount:doc.data().usercount,
        // TeamOnetotalAmount:doc.data().team1+" - "+doc.data().team1totalAmount,
        // TeamTwototalAmount:doc.data().team2+" - "+doc.data().team2totalAmount,
        // DrawtotalAmount:"Draw"+" - "+doc.data().team3totalAmount,

        // TotalBettingAmount:doc.data().bettingamount,

        StartDate: moment(doc.data().starttime.seconds * 1000).format(
          "DD-MMM-YYYY , hh:mm:ss:a"
        ),
        EndDate: moment(doc.data().endtime.seconds * 1000).format(
          "DD-MMM-YYYY , hh:mm:ss:a"
        ),
      };
      return smallDocument;
    },
    getbettinglist() {
      this.tableData2 = [];
      // let dbs = secondaryDB.secondaryDatabase;
      secondaryDatabase
        .collection("bettingtest")
        .where("dfs", "==", true)
        //   .orderBy("quizdate","desc")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.tableData2.push(this.assignsmallData(doc));
          });
          this.getquiz();
          this.loading = false;
        });
    },
    rowClicked(item, index, column, e) {
      this.documentId = item.id;
    },

    deleteRoute(item) {
      this.documentId = item.id;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.deletecompanyDetails();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    deletecompanyDetails(item) {
      db.collection("messagetest")
        .doc(this.documentId)
        .delete()
        .then(() => {
          this.getmessage();
          window.location.reload();
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    },
    // sendmsg(){}
  },
  created() {
    this.getbettinglist();
    // this.sendmsg();
  },
};
</script>
<style >
.swal2-cancel {
  margin: 10px !important;
}
.sk-wave-rect {
  background-color: #4638c2;
  height: 100%;
  width: 15%;
  -webkit-animation: sk-wave 1.2s ease-in-out infinite;
  animation: sk-wave 1.2s ease-in-out infinite;
}
</style>